// Entry point for the build script in your package.json

// Rails UJS
import Rails from "@rails/ujs";
Rails.start();

// React
import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);

import "./lib/animation";
import "./frontend/background";
import "./frontend/file_drop";
import "./frontend/mobile_nav";
import "./frontend/toast";
